/* import __COLOCATED_TEMPLATE__ from './debug-data-value.hbs'; */
import Component from '@glimmer/component';

// TODO: The data involved here and in the test is ambiguous - we need to lock this to a single type
interface DebugDataValueSignature {
  Args: { value?: number | null };
  Element: HTMLSpanElement;
}

export default class DebugDataValue extends Component<DebugDataValueSignature> {
  get formattedValue() {
    let result: string | number = this.args.value ?? NaN;
    console.log(result); //eslint-disable-line no-console
    if (isNaN(result)) {
      result = '-';
    }
    return result;
  }
}
declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    DebugDataValue: typeof DebugDataValue;
  }
}
